<!-- eslint-disable -->
<template lang="pug">
    .olympiad-banner(
        @click="openOlympiad",
        :class=`[
            isAllowToAnimate && isAnimated && 'olympiad-banner--animated',
        ]`,
        @mouseover="stopInterval",
        @mouseout="startInterval",
        :style="bannerStyle"
    )
        .olympiad-banner__general-info
            .olympiad-banner__date {{ olympiadDate }}
            a.olympiad-banner__information-link(
                href="https://cleverstart.ru/onlayn-olimpiady-po-mentalnoy-arifmetike-cleverstart",
                target="_blank"
            ) {{ $i18n.t('olympiads.olympiads_banner_info') }}
        .olympiad-banner__info
            .olympiad-banner__name {{ olympiad.name }}
            .olympiad-banner__status
                template(v-if="olympiad.isRegistrationEnded && !olympiad.authUserRegisteredLevel")
                    |	{{ $i18n.t('olympiads.olympiads_preview_registerIsClosed') }}
                template(v-else-if="!olympiad.isRegistrationAllowed && !olympiad.authUserRegisteredLevel")
                    | {{ beforeRegistration }}
                template(v-else-if="olympiad.isRegistrationAllowed")
                    cs-button.olympiad-banner__button(
                        color="blue"
                        @click="olympiadRegister"
                    )
                        | {{ $i18n.t('olympiads.olympiads_notification_register') }}
                template(v-else-if="olympiad.authUserRegisteredLevel.secondsToStart > 0")
                    | {{ $i18n.t('olympiads.olympiads_notification_beforeStart') + ' ' + timeToStart }}
                template(v-else)
                    cs-button.olympiad-banner__button(
                        color="blue"
                        @click="olympiadRegister"
                    )
                        | {{ $i18n.t('olympiads.olympiads_notification_start') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        props: {
            olympiad: Object
        },
        data () {
            return {
                timer: null,
                animateInterval: null,
                isAnimated: false
            }
        },
        mounted () {
            this.startInterval();
            if (!this.olympiad.isRegistrationAllowed && this.olympiad.authUserRegisteredLevel) {
                this.timer = setInterval(() => {
                    --this.olympiad.authUserRegisteredLevel.secondsToStart;
                    !this.olympiad.authUserRegisteredLevel.secondsToStart && clearInterval(this.timer);
                }, 1000);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            olympiadDate () {
                return moment(this.olympiad.date).format('DD MMMM YYYY');
            },
            timeToStart() {
                let years = this.momentDuration.years();
                let months = this.momentDuration.months();
                let days = this.momentDuration.days();
                let hours = this.momentDuration.hours();
                let minutes = this.momentDuration.minutes();
                let seconds = this.momentDuration.seconds();
                let resultString = '';
                if (years) {
                    resultString += years + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_years', years) + ' ';
                }
                if (months) {
                    resultString += months + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_months', months) + ' ';
                }
                if (days) {
                    resultString += days + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_days', days) + ' ';
                }
                if (hours) {
                    resultString += hours + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_hours', hours) + ' ';
                }
                if (minutes) {
                    resultString += minutes + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_minutes', minutes) + ' ';
                }
                resultString += seconds + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', seconds);
                return resultString;
            },
            momentDuration() {
                return moment.duration(this.olympiad.authUserRegisteredLevel.secondsToStart, 'seconds');
            },
            beforeRegistration () {
                return this.$i18n.t('olympiads.olympiads_preview_registerWillBegin')
                        + moment(this.olympiad.registrationStart).format('DD MMM YYYY')
                        + this.$i18n.t('olympiads.olympiads_preview_in')
                        + moment(this.olympiad.registrationStart).format('HH:mm')
                        + this.$i18n.t('olympiads.olympiads_preview_timezone');
            },
            bannerStyle () {
                return {
                    background: `linear-gradient(360deg, rgba(0, 0, 0, 0.8) -23.26%, rgba(0, 0, 0, 0) 82.18%), url(${this.olympiad.backgroundImage})`,
                    'background-size': 'cover',
                    'background-position': 'center center'
                };
            },
            isAllowToAnimate () {
                return this.olympiad.isRegistrationAllowed
                        || (this.olympiad.authUserRegisteredLevel && this.olympiad.authUserRegisteredLevel.secondsToStart <= 0);
            },
        },
        methods: {
            openOlympiad () {
                if (this.user.type === 'admin' || this.user.type === 'teacher') return;
                if (this.olympiad.isRegistrationAllowed) {
                    this.$router.push({name: 'olympiads:register', params: {id: this.olympiad.id}});
                    return;
                }
                this.$router.push({name: 'olympiads:show', params: {id: this.olympiad.id}});
            },
            olympiadRegister () {
                if (this.user.type === 'admin' || this.user.type === 'teacher') return;
                if(this.olympiad.isRegistrationAllowed) {
                    this.$router.push({name: 'olympiads:register', params: {id: this.olympiad.id}});
                    return;
                }
                this.$router.push({name: 'olympiads:start', params: {id: this.olympiad.authUserRegisteredLevel.id}});
            },
            startInterval () {
                this.animateInterval = setInterval(() => {
                    this.isAnimated = !this.isAnimated;
                }, 600);
            },
            stopInterval () {
                if (this.animateInterval) {
                    clearInterval(this.animateInterval);
                    this.isAnimated = false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-banner {
      cursor: pointer;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        transition: transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);

        background-size: cover;
        background-repeat: no-repeat;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 370px;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .olympiad-banner--animated {
        transform: scale(1.03);
    }

    .olympiad-banner__general-info {
        display: flex;
        flex-direction: column;
        @include media($sm) {
          flex-direction: row;
          justify-content: space-between;
        }
    }

    .olympiad-banner__date {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background: #6BBD6C;
        border-radius: 40px;
        color: $x-color-white;
        padding: 8px 14px;
        width: fit-content;
        margin-left: 7px;
        margin-top: 20px;
        @include media($lg) {
          margin-left: 5px;
        }
    }

    .olympiad-banner__information-link {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background: #1f87ff;
        border-radius: 40px;
        color: $x-color-white;
        padding: 8px 14px;
        width: fit-content;
        margin-left: 7px;
        margin-top: 20px;
        @include media($sm) {
          margin-right: 5px;
        }
    }

    .olympiad-banner__button {
        margin-top: 20px;
    }

    .olympiad-banner__info {
        margin: 0 30px 30px;
    }

    .olympiad-banner__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
    }

    .olympiad-banner__status {
        font-size: 16px;
        line-height: 19px;
        color: $x-color-white;
    }
</style>
